import React from "react";
import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
  Youtube,
  Globe,
} from "lucide-react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#000000] text-gray-200 w-full border-t-8 border-[#f2c34d]">
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16">

        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">

          {/* Company Info */}
          <div className="lg:col-span-4 space-y-4">
            <div className="flex items-start space-x-4">
              <img
                src="/logo.png"
                alt="Braj Decor Logo"
                className="w-[90px] h-[90px] object-contain"
              />
              <div>
                <h3 className="text-lg font-bold text-yellow-500">
                  Braj Decor & Designers
                </h3>
                <p className="text-sm">
                  Interior & Architectural Design
                </p>
              </div>
            </div>

            <p className="text-gray-300 text-sm leading-relaxed mt-3">
              At Braj Decor & Designers, we specialize in creating innovative
              and elegant architectural and interior design solutions in
              Varanasi. Our expertise transforms every space into a functional
              masterpiece, blending modern trends with timeless beauty.
            </p>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h4 className="text-lg font-semibold text-yellow-500 mb-4 border-l-2 border-yellow-500 pl-2">
              QUICK LINKS
            </h4>
            <nav className="space-y-2 text-sm">
              {["Home", "About", "Services", "FAQ", "Portfolio", "Contact"].map(
                (name) => (
                  <Link
                    key={name}
                    to={
                      name === "Home"
                        ? "/"
                        : `/${name.toLowerCase().replace(/\s/g, "")}`
                    }
                    className="flex items-center space-x-2 hover:text-yellow-500 transition-colors"
                  >
                    <span className="text-yellow-500">›</span>
                    <span>{name}</span>
                  </Link>
                )
              )}
            </nav>
          </div>

          {/* Our Services */}
          <div className="lg:col-span-3">
            <h4 className="text-lg font-semibold text-yellow-500 mb-4 border-l-2 border-yellow-500 pl-2">
              OUR SERVICES
            </h4>
            <div className="space-y-2 text-sm">
              {[
                "Architecture",
                "Interior Design",
                "3D & 2D Exterior Design",
                "Map Approval",
              ].map((service) => (
                <div
                  key={service}
                  className="flex items-center space-x-2 hover:text-yellow-500 transition-colors"
                >
                  <span className="text-yellow-500">›</span>
                  <span>{service}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-3">
            <h4 className="text-lg font-semibold text-yellow-500 mb-4 border-l-2 border-yellow-500 pl-2">
              CONTACT DETAILS
            </h4>

            <div className="space-y-4 text-sm">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-yellow-500" />
                <span>
                  +91 7311118002 , +91 9889690900 , +91 9119901924
                </span>
              </div>

              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-yellow-500" />
                <span>brajdecoranddesigner@gmail.com</span>
              </div>

              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-yellow-500 mt-1" />
                <p>
                  Baba Vishwanath Negar Colony,
                  <br /> Ashokpuram Colony, Dafi, Varanasi
                </p>
              </div>

              {/* Social Media Icons */}
              <div className="flex items-center space-x-4 pt-4">
                <a
                  href="https://www.facebook.com/profile.php?id=61585600680876"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1a1a1a] hover:bg-yellow-500 transition-all duration-300"
                >
                  <Facebook className="w-4 h-4 text-yellow-500 hover:text-black" />
                </a>

                <a
                  href="https://www.instagram.com/brajdecoranddesigners/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1a1a1a] hover:bg-yellow-500 transition-all duration-300"
                >
                  <Instagram className="w-4 h-4 text-yellow-500 hover:text-black" />
                </a>

                <a
                  href="https://www.youtube.com/@brajdecoranddesigner1420"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1a1a1a] hover:bg-yellow-500 transition-all duration-300"
                >
                  <Youtube className="w-4 h-4 text-yellow-500 hover:text-black" />
                </a>

                <a
                  href="https://brajdecoranddesigners.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1a1a1a] hover:bg-yellow-500 transition-all duration-300"
                >
                  <Globe className="w-4 h-4 text-yellow-500 hover:text-black" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-12 pt-6 text-center text-sm text-gray-400">
          © {currentYear} Braj Decor & Designers | Design by{" "}
          <span className="text-yellow-500">Shubham Infotech</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;